// extracted by mini-css-extract-plugin
export var marginNegative = "_64-5 _64-3 _64-1";
export var marginPositive = "_64-4 _64-3 _64-1";
export var modalContent = "_64-6";
export var samplesTable = "_64-8";
export var samplesTableContainer = "_64-7";
export var statBox = "_64-a";
export var tableCell = "_64-1";
export var tableCellCenter = "_64-2 _64-1";
export var tableCellRight = "_64-3 _64-1";
export var tableHeader = "_64-0";
export var trackingNumber = "_64-9";